import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { DebounceInput } from 'react-debounce-input';
import useLocalSearchShortcut from '../../shared/hooks/useLocalSearchShortcut';

const TeamSearchBar = ({ searchTerm, onSearchChange, placeholder = 'Search team members...' }) => {
  const searchInputRef = useRef(null);
  const shortcut = useLocalSearchShortcut(searchInputRef);

  return (
    <div className="team-search-wrapper">
      <i className="fas fa-search team-search-icon"></i>
      <DebounceInput
        inputRef={searchInputRef}
        type="search"
        debounceTimeout={300}
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        }}
        aria-label="Search team members"
        className="team-search-input"
      />
      {shortcut && <span className="team-search-shortcut">{shortcut}</span>}
    </div>
  );
};

TeamSearchBar.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
};

export default TeamSearchBar;
